import { Whatshot } from '@mui/icons-material';
import { Box, List, Typography } from '@mui/material';
import { MediaIcons } from '@prismamedia/one-components';
import {
  ArticleFormat,
  ArticleFragment_Article_channels_ArticleChannel,
} from '__generated__/queries-web';
import { FC, Fragment, useMemo } from 'react';
import { theme } from 'theme';
import { BlockItemFormat } from '..';
import { BlockItemType } from '../../../utils';

interface BlockItemFooterProps {
  articleProps: Partial<BlockItemType>;
  format: BlockItemFormat;
}
export const BlockItemFooter: FC<BlockItemFooterProps> = ({
  articleProps: {
    articleCategories,
    articleChannels,
    articleEvents,
    format,
    pushCount,
    medias,
  },
  format: blockItemFormat,
}) => {
  const displayTitle = (
    articleData: ArticleFragment_Article_channels_ArticleChannel[] = [],
  ) => articleData.map((article) => article.category.title);

  const categoryTitle = useMemo(() => {
    const title =
      format === ArticleFormat.Video
        ? displayTitle(articleChannels)
        : displayTitle(articleCategories);

    if (!title.length) {
      return null;
    }

    return title.length === 2 ? `${title[0]} / ${title[1]}` : title[0];
  }, [format, articleCategories, articleChannels]);

  const eventTitle = useMemo(() => {
    if (articleEvents?.length) {
      return articleEvents.length === 2
        ? `${articleEvents[0].category.title}, ${articleEvents[1].category.title}`
        : articleEvents[0].category.title;
    }
  }, [articleEvents]);

  if (blockItemFormat === BlockItemFormat.EXPANDED) {
    return <Fragment />;
  }

  return (
    <Box
      sx={{
        alignItems: 'flex-end',
        display: 'flex',
        mt: 'auto',
      }}
    >
      <Box>
        {eventTitle && (
          <Typography
            sx={{
              color: theme.palette.grey['500'],
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            variant="body2"
          >
            {eventTitle}
          </Typography>
        )}

        {categoryTitle && (
          <Typography
            sx={{
              color: theme.palette.primary.main,
              mt: theme.spacing(0.15),
            }}
            variant="body2"
          >
            {categoryTitle}
          </Typography>
        )}
      </Box>
      <List sx={{ ml: 'auto' }} disablePadding>
        <MediaIcons
          medias={medias}
          additionnalIcons={
            pushCount ? [{ Icon: Whatshot, count: pushCount }] : []
          }
        />
      </List>
    </Box>
  );
};
